<script>


	let wsObj;
	let wsUrl = 'wss://www.gasnow.org/ws';

	let rapid = 0;
	let fast = 0;
	let standard = 0;
	let slow = 0;
	let el;
	let gasload = false;

	let setFirstGas = false;
	let setFirstPrice = false;

	let updatePageGasPriceData = (data) => {
		console.log(data.gasPrices);
		if(!gasload) {
			gasload = true;
			el = document.getElementById("rapid");
			el.classList.remove("is-loading");
			el = document.getElementById("fast");
			el.classList.remove("is-loading");
			el = document.getElementById("standard");
			el.classList.remove("is-loading");
			el = document.getElementById("slow");
			el.classList.remove("is-loading");
		}

		if (data && data.gasPrices) {
			rapid = Math.floor(data.gasPrices.rapid / 1e9) || 0;
			fast = Math.floor(data.gasPrices.fast / 1e9) || 0;
			standard = Math.floor(data.gasPrices.standard / 1e9) || 0;
			slow = Math.floor(data.gasPrices.slow / 1e9) || 0;

			if (!setFirstGas) {
				setFirstGas = true;
				gas_price = fast;
			}
		}
	};

	wsObj = new WebSocket(wsUrl);
	wsObj.onopen = (evt) => {
		console.log("Connection open ...");
	};

	wsObj.onmessage = (evt) => {
		const dataStr = evt.data;
		const data = JSON.parse(dataStr);

		if (data.type) {
			updatePageGasPriceData(data.data)
		}
	};

	wsObj.onclose = (evt) => {
		console.log("Connection closed.");
	};

	//////////////eth price//////////////////////

	let ethprice = 0;
	var element;
	let ethpriceremoved = false;
	function reqListener() {
		if(!ethpriceremoved) {
			element = document.getElementById("ethprice");
			element.classList.remove("is-loading");
		}
		ethprice = JSON.parse(this.responseText).ethereum.usd ?? 0;

		if (!setFirstPrice) {
			setFirstPrice = true;
			ethpriceinput = ethprice;
		}

		console.log(ethprice);
	}

	function get_ethprice() {
		var oReq = new XMLHttpRequest();
		oReq.addEventListener("load", reqListener);
		oReq.open("GET", "https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd");
		oReq.send();
	}
	get_ethprice();
	var ethinterval = window.setInterval(function () {
		get_ethprice();
	}, 10000);

	let r = [];
	for(let i = 0; i < 24; i++) {
		r.push([]);
		for (let j = 0; j < 7; j++) {
			r[i].push('')
		}
	}
	let days = [];
	let currentTime = new Date();
	let currentDay = currentTime.getDate();
	let names = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December"
	];
	for (let j = 6; j >= 0; j--){
		let jDaysAgo = new Date();
		jDaysAgo.setDate(jDaysAgo.getDate() - j);
		days.push(names[jDaysAgo.getMonth()] + " " + jDaysAgo.getDate());
	}

	function foo(value) {
		console.log(value);
		gas_price = value;
	}

	function hourlyGasListener() {
		let result = JSON.parse(this.responseText);
		let data = result.data;

		let currentTime = new Date();
		let currentDay = currentTime.getDate();

		let currentHour = currentTime.getHours();
		let removedHours = 24 - currentHour;


		for (let i = removedHours; i < data.length; i++){
			let fast_price = data[i].min;
			let data_time = new Date(data[i].time);


			
			
			let dayDifference = currentTime.getDay() - data_time.getDay();
			let tableColumnIndex = (dayDifference + 7) % 7;
			console.log(tableColumnIndex);
			if (tableColumnIndex >= 0 && tableColumnIndex < 7) {
				tableColumnIndex = 6 - tableColumnIndex;
				r[data_time.getHours()][tableColumnIndex] = Math.floor(fast_price / 1e9);
			}
			

			
			
		}

	}

	function get_hourlyData() {
		var oReq = new XMLHttpRequest();
		oReq.addEventListener("load", hourlyGasListener);
		oReq.open("GET", "https://www.gasnow.org/api/v3/block/history?filter=y&zoom=w&utm_source=web");
		oReq.send();
	}

	window.setTimeout(get_hourlyData, 100)


	let gas_used = 100000;
	let gas_price = 0;
	let ethpriceinput = 0;

	function handleGasClick(val) {
		gas_price = val;
	}

	function handlePrice() {
		ethpriceinput = ethprice;
	}

	export let name;
</script>

<main>
	<button on:click={handlePrice} id="ethprice" class="button title is-5 is-loading" style="cursor: pointer">ETH: ${ethprice}</button>
	<div id="gas" class="columns is-vcentered">
		<h1 class="column title is-1" style="margin:0">⛽</h1>
		<div class="column">
			<button id="rapid" class="button is-danger is-light is-loading" on:click={handleGasClick(rapid)}>
				<span class="title is-5">Rapid</span>
				<p>{rapid}</p>
			</button>
		</div>
		<div class="column">
			<button id="fast" class="button is-warning is-light is-loading" on:click={handleGasClick(fast)}>
				<span class="title is-5">Fast</span>
				<p>{fast}</p>
			</button>
		</div>
		<div class="column">
			<button id="standard" class="button is-primary is-light is-loading" on:click={handleGasClick(standard)}>
				<span class="title is-5">Standard</span>
				<p>{standard}</p>
			</button>
		</div>
		<div class="column">
			<button id="slow" class="button is-success is-light is-loading" on:click={handleGasClick(slow)}>
				<span class="title is-5">Slow</span>
				<p>{slow}</p>
			</button>
		</div>
	</div>

	<div class="columns">
		<div class="column is-2 is-offset-3">
			<div class="field">
				<label class="label">Gas used</label>
				<div class="control">
					<input bind:value={gas_used} min="0" class="input has-text-centered" type="number" placeholder="Gas used">
				</div>
			</div>
		</div>
		<div class="column is-2 is-offset-0<">
			<div class="field">
				<label class="label">Gas price (Gwei)</label>
				<div class="control">
					<input bind:value={gas_price} min="0" class="input has-text-centered" type="number" placeholder="Gas price">
				</div>
			</div>
		</div>
		<div class="column is-2 is-offset-0<">
			<div class="field">
				<label class="label">Eth price ($)</label>
				<div class="control">
					<input bind:value={ethpriceinput} min="0" class="input has-text-centered" type="number" placeholder="Eth value">
				</div>
			</div>
		</div>
	</div>

	<div class="columns">
		<div class="column is-2 is-offset-4 has-text-centered">Estimated fee: </div>
		<div class="column is-2 has-text-centered">${(gas_used*(gas_price/1e9*ethpriceinput)).toFixed(2)}</div>
	</div>

	<div class="columns">
		<div class="column is-2 is-offset-4 has-text-centered">Estimated impact: </div>
		<div class="column is-2 has-text-centered">{(gas_used*(gas_price/1e9*ethpriceinput)*1.151).toFixed(2)} KgCO<sub>2</sub>eq
		</div>
	</div>

	<div class="columns">
		<div class="column">
			<h1 class="title is-5">Equivalent to driving {(gas_used*(gas_price/1e9*ethpriceinput)*1.151 / 0.404).toFixed(2)} miles</h1>
		</div>
	</div>

	<div class="gas_speed">
		<div class="columns" id="gas_speed">
			<div class="column is-2 is-offset-4 has-text-centered">Rapid: </div>
			<div class="column is-2 has-text-centered">{(gas_used*(rapid/1e9*ethpriceinput)*1.151).toFixed(2)} KgCO<sub>2</sub>eq
			</div>
		</div>
		<div class="columns">
			<div class="column is-2 is-offset-4 has-text-centered">Fast: </div>
			<div class="column is-2 has-text-centered">{(gas_used*(fast/1e9*ethpriceinput)*1.151).toFixed(2)} KgCO<sub>2</sub>eq</div>
		</div>
		<div class="columns">
			<div class="column is-2 is-offset-4 has-text-centered">Standard: </div>
			<div class="column is-2 has-text-centered">{(gas_used*(standard/1e9*ethpriceinput)*1.151).toFixed(2)} KgCO<sub>2</sub>eq
			</div>
		</div>
		<div class="columns">
			<div class="column is-2 is-offset-4 has-text-centered">Slow: </div>
			<div class="column is-2 has-text-centered">{(gas_used*(slow/1e9*ethpriceinput)*1.151).toFixed(2)} KgCO<sub>2</sub>eq</div>
		</div>
	</div>

</main>
	<table class="table is-widescreen" id="hourTable" style="cursor:pointer">
		<thead>
			<tr>
				<th>Hour</th>
				<th id="day1">{days[0]}</th>
				<th id="day2">{days[1]}</th>
				<th id="day3">{days[2]}</th>
				<th id="day4">{days[3]}</th>
				<th id="day5">{days[4]}</th>
				<th id="day6">{days[5]}</th>
				<th id="day7">{days[6]}</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<tr>
					<th>0:00</th>
					<td on:click={foo(r[0][0])}>{r[0][0]}</td>
					<td on:click={foo(r[0][1])}>{r[0][1]}</td>
					<td on:click={foo(r[0][2])}>{r[0][2]}</td>
					<td on:click={foo(r[0][3])}>{r[0][3]}</td>
					<td on:click={foo(r[0][4])}>{r[0][4]}</td>
					<td on:click={foo(r[0][5])}>{r[0][5]}</td>
					<td on:click={foo(r[0][6])}>{r[0][6]}</td>
					</tr>
					<tr>
					<th>1:00</th>
					<td on:click={foo(r[1][0])}>{r[1][0]}</td>
					<td on:click={foo(r[1][1])}>{r[1][1]}</td>
					<td on:click={foo(r[1][2])}>{r[1][2]}</td>
					<td on:click={foo(r[1][3])}>{r[1][3]}</td>
					<td on:click={foo(r[1][4])}>{r[1][4]}</td>
					<td on:click={foo(r[1][5])}>{r[1][5]}</td>
					<td on:click={foo(r[1][6])}>{r[1][6]}</td>
					</tr>
					<tr>
					<th>2:00</th>
					<td on:click={foo(r[2][0])}>{r[2][0]}</td>
					<td on:click={foo(r[2][1])}>{r[2][1]}</td>
					<td on:click={foo(r[2][2])}>{r[2][2]}</td>
					<td on:click={foo(r[2][3])}>{r[2][3]}</td>
					<td on:click={foo(r[2][4])}>{r[2][4]}</td>
					<td on:click={foo(r[2][5])}>{r[2][5]}</td>
					<td on:click={foo(r[2][6])}>{r[2][6]}</td>
					</tr>
					<tr>
					<th>3:00</th>
					<td on:click={foo(r[3][0])}>{r[3][0]}</td>
					<td on:click={foo(r[3][1])}>{r[3][1]}</td>
					<td on:click={foo(r[3][2])}>{r[3][2]}</td>
					<td on:click={foo(r[3][3])}>{r[3][3]}</td>
					<td on:click={foo(r[3][4])}>{r[3][4]}</td>
					<td on:click={foo(r[3][5])}>{r[3][5]}</td>
					<td on:click={foo(r[3][6])}>{r[3][6]}</td>
					</tr>
					<tr>
					<th>4:00</th>
					<td on:click={foo(r[4][0])}>{r[4][0]}</td>
					<td on:click={foo(r[4][1])}>{r[4][1]}</td>
					<td on:click={foo(r[4][2])}>{r[4][2]}</td>
					<td on:click={foo(r[4][3])}>{r[4][3]}</td>
					<td on:click={foo(r[4][4])}>{r[4][4]}</td>
					<td on:click={foo(r[4][5])}>{r[4][5]}</td>
					<td on:click={foo(r[4][6])}>{r[4][6]}</td>
					</tr>
					<tr>
					<th>5:00</th>
					<td on:click={foo(r[5][0])}>{r[5][0]}</td>
					<td on:click={foo(r[5][1])}>{r[5][1]}</td>
					<td on:click={foo(r[5][2])}>{r[5][2]}</td>
					<td on:click={foo(r[5][3])}>{r[5][3]}</td>
					<td on:click={foo(r[5][4])}>{r[5][4]}</td>
					<td on:click={foo(r[5][5])}>{r[5][5]}</td>
					<td on:click={foo(r[5][6])}>{r[5][6]}</td>
					</tr>
					<tr>
					<th>6:00</th>
					<td on:click={foo(r[6][0])}>{r[6][0]}</td>
					<td on:click={foo(r[6][1])}>{r[6][1]}</td>
					<td on:click={foo(r[6][2])}>{r[6][2]}</td>
					<td on:click={foo(r[6][3])}>{r[6][3]}</td>
					<td on:click={foo(r[6][4])}>{r[6][4]}</td>
					<td on:click={foo(r[6][5])}>{r[6][5]}</td>
					<td on:click={foo(r[6][6])}>{r[6][6]}</td>
					</tr>
					<tr>
					<th>7:00</th>
					<td on:click={foo(r[7][0])}>{r[7][0]}</td>
					<td on:click={foo(r[7][1])}>{r[7][1]}</td>
					<td on:click={foo(r[7][2])}>{r[7][2]}</td>
					<td on:click={foo(r[7][3])}>{r[7][3]}</td>
					<td on:click={foo(r[7][4])}>{r[7][4]}</td>
					<td on:click={foo(r[7][5])}>{r[7][5]}</td>
					<td on:click={foo(r[7][6])}>{r[7][6]}</td>
					</tr>
					<tr>
					<th>8:00</th>
					<td on:click={foo(r[8][0])}>{r[8][0]}</td>
					<td on:click={foo(r[8][1])}>{r[8][1]}</td>
					<td on:click={foo(r[8][2])}>{r[8][2]}</td>
					<td on:click={foo(r[8][3])}>{r[8][3]}</td>
					<td on:click={foo(r[8][4])}>{r[8][4]}</td>
					<td on:click={foo(r[8][5])}>{r[8][5]}</td>
					<td on:click={foo(r[8][6])}>{r[8][6]}</td>
					</tr>
					<tr>
					<th>9:00</th>
					<td on:click={foo(r[9][0])}>{r[9][0]}</td>
					<td on:click={foo(r[9][1])}>{r[9][1]}</td>
					<td on:click={foo(r[9][2])}>{r[9][2]}</td>
					<td on:click={foo(r[9][3])}>{r[9][3]}</td>
					<td on:click={foo(r[9][4])}>{r[9][4]}</td>
					<td on:click={foo(r[9][5])}>{r[9][5]}</td>
					<td on:click={foo(r[9][6])}>{r[9][6]}</td>
					</tr>
					<tr>
					<th>10:00</th>
					<td on:click={foo(r[10][0])}>{r[10][0]}</td>
					<td on:click={foo(r[10][1])}>{r[10][1]}</td>
					<td on:click={foo(r[10][2])}>{r[10][2]}</td>
					<td on:click={foo(r[10][3])}>{r[10][3]}</td>
					<td on:click={foo(r[10][4])}>{r[10][4]}</td>
					<td on:click={foo(r[10][5])}>{r[10][5]}</td>
					<td on:click={foo(r[10][6])}>{r[10][6]}</td>
					</tr>
					<tr>
					<th>11:00</th>
					<td on:click={foo(r[11][0])}>{r[11][0]}</td>
					<td on:click={foo(r[11][1])}>{r[11][1]}</td>
					<td on:click={foo(r[11][2])}>{r[11][2]}</td>
					<td on:click={foo(r[11][3])}>{r[11][3]}</td>
					<td on:click={foo(r[11][4])}>{r[11][4]}</td>
					<td on:click={foo(r[11][5])}>{r[11][5]}</td>
					<td on:click={foo(r[11][6])}>{r[11][6]}</td>
					</tr>
					<tr>
					<th>12:00</th>
					<td on:click={foo(r[12][0])}>{r[12][0]}</td>
					<td on:click={foo(r[12][1])}>{r[12][1]}</td>
					<td on:click={foo(r[12][2])}>{r[12][2]}</td>
					<td on:click={foo(r[12][3])}>{r[12][3]}</td>
					<td on:click={foo(r[12][4])}>{r[12][4]}</td>
					<td on:click={foo(r[12][5])}>{r[12][5]}</td>
					<td on:click={foo(r[12][6])}>{r[12][6]}</td>
					</tr>
					<tr>
					<th>13:00</th>
					<td on:click={foo(r[13][0])}>{r[13][0]}</td>
					<td on:click={foo(r[13][1])}>{r[13][1]}</td>
					<td on:click={foo(r[13][2])}>{r[13][2]}</td>
					<td on:click={foo(r[13][3])}>{r[13][3]}</td>
					<td on:click={foo(r[13][4])}>{r[13][4]}</td>
					<td on:click={foo(r[13][5])}>{r[13][5]}</td>
					<td on:click={foo(r[13][6])}>{r[13][6]}</td>
					</tr>
					<tr>
					<th>14:00</th>
					<td on:click={foo(r[14][0])}>{r[14][0]}</td>
					<td on:click={foo(r[14][1])}>{r[14][1]}</td>
					<td on:click={foo(r[14][2])}>{r[14][2]}</td>
					<td on:click={foo(r[14][3])}>{r[14][3]}</td>
					<td on:click={foo(r[14][4])}>{r[14][4]}</td>
					<td on:click={foo(r[14][5])}>{r[14][5]}</td>
					<td on:click={foo(r[14][6])}>{r[14][6]}</td>
					</tr>
					<tr>
					<th>15:00</th>
					<td on:click={foo(r[15][0])}>{r[15][0]}</td>
					<td on:click={foo(r[15][1])}>{r[15][1]}</td>
					<td on:click={foo(r[15][2])}>{r[15][2]}</td>
					<td on:click={foo(r[15][3])}>{r[15][3]}</td>
					<td on:click={foo(r[15][4])}>{r[15][4]}</td>
					<td on:click={foo(r[15][5])}>{r[15][5]}</td>
					<td on:click={foo(r[15][6])}>{r[15][6]}</td>
					</tr>
					<tr>
					<th>16:00</th>
					<td on:click={foo(r[16][0])}>{r[16][0]}</td>
					<td on:click={foo(r[16][1])}>{r[16][1]}</td>
					<td on:click={foo(r[16][2])}>{r[16][2]}</td>
					<td on:click={foo(r[16][3])}>{r[16][3]}</td>
					<td on:click={foo(r[16][4])}>{r[16][4]}</td>
					<td on:click={foo(r[16][5])}>{r[16][5]}</td>
					<td on:click={foo(r[16][6])}>{r[16][6]}</td>
					</tr>
					<tr>
					<th>17:00</th>
					<td on:click={foo(r[17][0])}>{r[17][0]}</td>
					<td on:click={foo(r[17][1])}>{r[17][1]}</td>
					<td on:click={foo(r[17][2])}>{r[17][2]}</td>
					<td on:click={foo(r[17][3])}>{r[17][3]}</td>
					<td on:click={foo(r[17][4])}>{r[17][4]}</td>
					<td on:click={foo(r[17][5])}>{r[17][5]}</td>
					<td on:click={foo(r[17][6])}>{r[17][6]}</td>
					</tr>
					<tr>
					<th>18:00</th>
					<td on:click={foo(r[18][0])}>{r[18][0]}</td>
					<td on:click={foo(r[18][1])}>{r[18][1]}</td>
					<td on:click={foo(r[18][2])}>{r[18][2]}</td>
					<td on:click={foo(r[18][3])}>{r[18][3]}</td>
					<td on:click={foo(r[18][4])}>{r[18][4]}</td>
					<td on:click={foo(r[18][5])}>{r[18][5]}</td>
					<td on:click={foo(r[18][6])}>{r[18][6]}</td>
					</tr>
					<tr>
					<th>19:00</th>
					<td on:click={foo(r[19][0])}>{r[19][0]}</td>
					<td on:click={foo(r[19][1])}>{r[19][1]}</td>
					<td on:click={foo(r[19][2])}>{r[19][2]}</td>
					<td on:click={foo(r[19][3])}>{r[19][3]}</td>
					<td on:click={foo(r[19][4])}>{r[19][4]}</td>
					<td on:click={foo(r[19][5])}>{r[19][5]}</td>
					<td on:click={foo(r[19][6])}>{r[19][6]}</td>
					</tr>
					<tr>
					<th>20:00</th>
					<td on:click={foo(r[20][0])}>{r[20][0]}</td>
					<td on:click={foo(r[20][1])}>{r[20][1]}</td>
					<td on:click={foo(r[20][2])}>{r[20][2]}</td>
					<td on:click={foo(r[20][3])}>{r[20][3]}</td>
					<td on:click={foo(r[20][4])}>{r[20][4]}</td>
					<td on:click={foo(r[20][5])}>{r[20][5]}</td>
					<td on:click={foo(r[20][6])}>{r[20][6]}</td>
					</tr>
					<tr>
					<th>21:00</th>
					<td on:click={foo(r[21][0])}>{r[21][0]}</td>
					<td on:click={foo(r[21][1])}>{r[21][1]}</td>
					<td on:click={foo(r[21][2])}>{r[21][2]}</td>
					<td on:click={foo(r[21][3])}>{r[21][3]}</td>
					<td on:click={foo(r[21][4])}>{r[21][4]}</td>
					<td on:click={foo(r[21][5])}>{r[21][5]}</td>
					<td on:click={foo(r[21][6])}>{r[21][6]}</td>
					</tr>
					<tr>
					<th>22:00</th>
					<td on:click={foo(r[22][0])}>{r[22][0]}</td>
					<td on:click={foo(r[22][1])}>{r[22][1]}</td>
					<td on:click={foo(r[22][2])}>{r[22][2]}</td>
					<td on:click={foo(r[22][3])}>{r[22][3]}</td>
					<td on:click={foo(r[22][4])}>{r[22][4]}</td>
					<td on:click={foo(r[22][5])}>{r[22][5]}</td>
					<td on:click={foo(r[22][6])}>{r[22][6]}</td>
					</tr>
					<tr>
					<th>23:00</th>
					<td on:click={foo(r[23][0])}>{r[23][0]}</td>
					<td on:click={foo(r[23][1])}>{r[23][1]}</td>
					<td on:click={foo(r[23][2])}>{r[23][2]}</td>
					<td on:click={foo(r[23][3])}>{r[23][3]}</td>
					<td on:click={foo(r[23][4])}>{r[23][4]}</td>
					<td on:click={foo(r[23][5])}>{r[23][5]}</td>
					<td on:click={foo(r[23][6])}>{r[23][6]}</td>
					</tr>		
		</tbody>
	</table>



<footer class="footer">
	<div class="content has-text-centered">
		<p>
			Based on <a href="https://github.com/lucadonnoh/GreenNFT">Green NFTs: A Study on the Environmental Impact of Cryptoart Technologies</a>
		</p>
		<p>
			Built and researched by <a href="https://twitter.com/lucadonnoh">Luca Donno</a> and <a href="https://twitter.com/MarroSamuele">Samuele Marro</a>
		</p>
	</div>
</footer>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	.gas_speed .columns {
		margin-bottom: -12px;
	}

	#suggestion {
		margin-top: 30px;
	}

	#gas button {
		margin: 0;
		padding: 30px;
		flex-direction: column;
		width: 80%;
	}

	#gas span {
		margin: 0;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
		#hourTable {
			padding-left: 10%;
			padding-right: 10%;
		}
	}
	@media (max-width: 640px) {
		main {
			margin: auto;
			width: 100%
		}
	}

	#hourTable {
		width: 100%;
	}

	#hourTable td {
		text-align:center;
	}
	#hourTable th {
		text-align:center;
	}

	#hourTable td:hover {
		background-color: whitesmoke;
	}

</style>